<template>
  <!-- 运单列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <!-- <el-button class="glo_btnItems" @click="receiveOrderV4"
          >批量接单</el-button
        >
        <el-button class="glo_btnItems" @click="clickSingleTicketDelivery"
          >送达签收</el-button
        > -->
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="printBtns">打印</el-dropdown-item> -->
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="160px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="TraceEntryBtns(scope.row)"
                >轨迹</el-button
              >
              <el-button class="rbtns" @click.stop="goDetails(scope.row)"
                >详情</el-button
              >
              <!-- <el-button
                class="rbtns"
                @click.stop="GoSettlementEntry(scope.row)"
                >附件</el-button
              > -->
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                  class="rbtns"
                  @command="handleCommandBtns($event, scope.row)"
                >
                  <el-button type="primary">
                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">详情</el-dropdown-item>
                    <el-dropdown-item command="b">外发录入</el-dropdown-item>
                    <el-dropdown-item command="c">改运单号</el-dropdown-item>
                    <el-dropdown-item command="d">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 送达签收 -->
    <myDialog
      :diaWidth="diaWidthDispatch"
      :dialogTitle="dialogTitleDispatch"
      :isShowDialog="isShowDialogDispatch"
      :showConfirm1="true"
      @handleCloseDia="handleCloseDiaDispatch"
      @diaCancelBtn="handleCloseDiaDispatch"
      @diaConfirmBtn="diaConfirmBtnDispatch()"
    >
      <div class="formbox" v-if="isShowDialogDispatch">
        <el-form class="glo_formBox" label-width="120px">
          <div class="qsr">
            <el-form-item label="签收人:">
              <el-input
                v-model="dialogFormDispatch.signForName"
                placeholder="请输入"
                :disabled="dialogFormDispatch.isReceiveUserSign"
              ></el-input>
            </el-form-item>
            <el-checkbox
              style="margin-top: 8px"
              v-model="dialogFormDispatch.isReceiveUserSign"
              >默认收货人</el-checkbox
            >
          </div>
          <el-form-item
            required
            class="dialogTims"
            label="签收时间:"
            prop="signForTime"
          >
            <el-date-picker
              v-model="dialogFormDispatch.signForTime"
              class="input"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item required label="签收情况:" prop="signForSituation">
            <el-select
              filterable
              clearable
              v-model="dialogFormDispatch.signForSituation"
              placeholder="请选择"
            >
              <el-option
                v-for="item in signForSituation"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input
              type="textarea"
              v-model="dialogFormDispatch.remarks"
            ></el-input>
          </el-form-item>
          <div class="uploadImg">
            <div>签收图片</div>
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="9"
            ></uploadimgs>
          </div>
          <div class="uploadImg">
            <div>回单上传</div>
            <uploadimgs
              @input="changeFileList2"
              :fileNameLists="fileNameLists2"
              :limit="9"
            ></uploadimgs>
          </div>
        </el-form>
      </div>
    </myDialog>

    <!-- 跟踪录入 -->
    <myDialog
      :diaWidth="diaWidthDispatch"
      :dialogTitle="dialogTitleDispatch"
      :isShowDialog="isShowDialogDispatch"
      :showConfirm1="true"
      @handleCloseDia="handleCloseDiaDispatch"
      @diaCancelBtn="handleCloseDiaDispatch"
      @diaConfirmBtn="diaConfirmBtnDispatch()"
    >
      <div class="formbox" v-if="isShowDialogDispatch">
        <el-form class="glo_formBox" label-width="120px">
          <div class="qsr">
            <el-form-item label="签收人:">
              <el-input
                v-model="dialogFormDispatch.signForName"
                placeholder="请输入"
                :disabled="dialogFormDispatch.isReceiveUserSign"
              ></el-input>
            </el-form-item>
            <el-checkbox
              style="margin-top: 8px"
              v-model="dialogFormDispatch.isReceiveUserSign"
              >默认收货人</el-checkbox
            >
          </div>
          <el-form-item
            required
            class="dialogTims"
            label="签收时间:"
            prop="signForTime"
          >
            <el-date-picker
              v-model="dialogFormDispatch.signForTime"
              class="input"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item required label="签收情况:" prop="signForSituation">
            <el-select
              filterable
              clearable
              v-model="dialogFormDispatch.signForSituation"
              placeholder="请选择"
            >
              <el-option
                v-for="item in signForSituation"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input
              type="textarea"
              v-model="dialogFormDispatch.remarks"
            ></el-input>
          </el-form-item>
          <div class="uploadImg">
            <div>签收图片</div>
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="9"
            ></uploadimgs>
          </div>
          <div class="uploadImg">
            <div>回单上传</div>
            <uploadimgs
              @input="changeFileList2"
              :fileNameLists="fileNameLists2"
              :limit="9"
            ></uploadimgs>
          </div>
        </el-form>
      </div>
    </myDialog>

    <!-- ======================打印组件======================== -->
    <prints
      :diaWidth_print="diaWidth_print"
      :dialogTitle_print="dialogTitle_print"
      :isShowDialog_print="isShowDialog_print"
      :dataList="dataList"
      :topData="topData"
      @handleCloseDia_print="handleCloseDia_print"
      @diaConfirmBtn_print="diaConfirmBtn_print"
    ></prints>
    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      modelTypeVal="调度配载模块"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleOk"
    ></printDialog>
    <!-- 创建和使用模板 -->
    <printSys
      :printForm="printForm"
      :title="printTitle"
      icon="el-icon-printer"
      @handleClose="handlePrintSysClose"
    >
      <printSysContent
        :printType="printType"
        :modelObj="modelObj"
        :modelClassName="modelClassName"
        :selectTableData="selectTableData"
      ></printSysContent>
    </printSys>
    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select v-model="modelClassName" placeholder style="width: 100%">
        <el-option
          v-for="(value, key) in classNameArr"
          :key="key"
          :label="value.name"
          :value="value.val"
        ></el-option>
      </el-select>
    </classNameDialog>
    <!-- ======================打印组件======================== -->

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
  </div>
</template>
  <script>
import tableList from "@/pages/commonJS/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
export default {
  mixins: [tableList, mixin_print, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    uploadimgs,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "运单列表", //导出时默认文件名
        apiName: "/v1/common/query/runCustomerPageReport", //导出的数据列表接口名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "customer_pc_waybill_list", //  页面标识
      reportFiledsNumber: "customer_pc_waybill_list", // 动态 条件、表头
      // 打印插件 每个页面不一样的
      // 模板className
      idarrs: [],
      classNameArr: [
        // {
        //   name: "车辆成本付款清单",
        //   val: "com.bami.service.tms.v3.admin.print.vo.AdminCarCostPrintDataV3tmsVo",
        // },
        // {
        //   name: "发车配载清单",
        //   val: "com.bami.service.tms.v3.admin.print.vo.AdminDispatchPrintDataV3tmsVo",
        // },
      ],
      // 默认的模板类型
      modelClassName: "",

      isShowDialogDispatch: false,
      dialogTitleDispatch: "送达签收",
      diaWidthDispatch: "60%",
      dialogFormDispatch: {
        isReceiveUserSign: true,
        remarks: "",
        signForName: "",
        signForSituation: "",
        signForTime: "zheng_chang:sign_for_situation",
        waybillTransportIds: [],
        rnOrderFileIds: [],
        signForFileIds: [],
      },
      driverList: [], //司机列表
      car_categoryList: [], //车辆分类
      isTractorList: [
        //是否牵引车
        { val: 0, name: "否" },
        { val: 1, name: "是" },
      ],
      carNumberList1: [], //车牌号码
      carNumberList2: [], //挂车号码
      fileNameLists: [],
      fileNameLists2: [],
      signForSituation: [],
    };
  },
  mounted() {
    // this.getConfDictValDownLists("car_category");
    // this.getObjectUserDownList("driver");
    // this.getcarNumberRmethod("");
    // this.getsignForSituation();
  },
  watch: {},
  methods: {
    // 签收情况
    getsignForSituation() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_sign_for_v3.sign_for_situation")
        .then((res) => {
          this.signForSituation = res || [];
        });
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array;
    },

    //附件
    GoSettlementEntry(row) {
      //
      this.$router.push({
        path: "/WaybillManage/WaybillAttachment",
        query: {
          waybillNumber: row.waybillNumber,
        },
      });
    },
    //详情
    goDetails(row) {
      //
      this.$router.push({
        path: "/WaybillManage/WaybillDetails",
        query: {
          waybillSplitId: row.waybillSplitId,
        },
      });
    },
    // 送达签收
    aaaaa() {},
    // 接单
    receiveOrderV4() {
      let that = this;
      let ids = [];
      let arrs = that.selectTableData || [];
      if (arrs.length < 1) {
        that.$message.error("请至少选择一条数据");
        return false;
      }

      arrs.forEach((item) => {
        ids.push(item.waybillTransportId);
      });
      that.$API
        .receiveOrderV4({
          waybillTransportIds: ids,
        })
        .then((res) => {
          that.$message.success(res.data.message || "操作成功");
          setTimeout(() => {
            that.queryBtn_ok();
          }, 1000);
        });
    },

    TraceEntryBtns(row) {
      this.$router.push({
        path: "/WaybillManage/WaybillTracking",
        query: {
          waybillNumber: row.waybillNumber,
        },
      });
    },

    clickSingleTicketDelivery(row) {
      if (this.selectTableData.length < 1) {
        this.$message.error("请选择需要签收的运单");
        return false;
      }
      let idarr = [];
      idarr = this.selectTableData.map((item) => {
        return item.waybillTransportId;
      });
      this.dialogFormDispatch.waybillTransportIds = idarr || [];
      this.dialogFormDispatch.id = row.id;
      this.dialogFormDispatch.orderType = row.orderType;
      this.isShowDialogDispatch = true;
    },
    handleCloseDiaDispatch() {
      this.isShowDialogDispatch = false;
      this.fileNameLists = [];
      this.fileNameLists2 = [];
      this.dialogFormDispatch = {
        isReceiveUserSign: true,
        remarks: "",
        signForName: "",
        signForSituation: "",
        signForTime: "zheng_chang:sign_for_situation",
        waybillTransportIds: [],
        rnOrderFileIds: [],
        signForFileIds: [],
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch() {
      let arr1 = []; //签收
      let arr2 = []; //回单
      arr1 = this.fileNameLists.map((item) => {
        return item.name;
      });
      arr2 = this.fileNameLists2.map((item) => {
        return item.name;
      });
      let param = {
        isReceiveUserSign: this.dialogFormDispatch.isReceiveUserSign ? 1 : 0,
        remarks: this.dialogFormDispatch.remarks || "",
        signForName: this.dialogFormDispatch.signForName || "",
        signForSituation: this.dialogFormDispatch.signForSituation || "",
        signForTime: this.dialogFormDispatch.signForTime || "",
        waybillTransportIds: this.dialogFormDispatch.waybillTransportIds || [],
        rnOrderFileIds: arr2,
        signForFileIds: arr1,
      };
      this.$API.signforWaybillV4(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.queryBtn_ok();
        this.handleCloseDiaDispatch();
      });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownLists(val) {
      this.$COMAPI.getConfDictValDownList(val).then((res) => {
        //车辆分类
        if (val == "car_category") {
          this.car_categoryList = res || [];
        }
      });
    },
    // 获取车辆下拉列表(拿车牌号码)
    changecarCategoryConfDictId(e) {
      if (e) {
        this.$API
          .CarDownList({
            pageStart: 1,
            pageTotal: 200,
            carNumber: "",
            carCategoryConfDictId: e, //车辆分类id
          })
          .then((res) => {
            this.carNumberList1 = res.data.result.data || [];
          });
      }
    },
    // 获取车辆下拉列表(拿挂车号码)
    getcarNumberRmethod(e) {
      this.$API
        .CarArchiveList({
          pageStart: 1,
          pageTotal: 200,
          carNumber: e || "",
        })
        .then((res) => {
          this.carNumberList2 = res.data.result.data || [];
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "driver") {
          this.driverList = res || [];
        }
      }); //获取网点列表
    },
    // ==================打印插件==================
    // 打印按钮
    printEvent(val) {
      let idarr = [];
      if (val) {
        idarr.push(val.dispatchId);
        this.selectTableData = [val];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要打印的数据");
          return false;
        }
        idarr = this.selectTableData.map((item) => {
          return item.dispatchId;
        });
      }
      console.log("idarr", idarr);
      this.idarrs = idarr;

      window.sessionStorage.setItem(
        "set_PrintSelectTableData",
        JSON.stringify(idarr)
      );
      this.dialogFrom.dialogVisible = true;
    },
    // 打印预览模板
    handleView(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = this.idarrs || [];
      // for (let i = 0; i < this.selectTableData.length; i++) {
      //   idarr.push(this.selectTableData[i].dispatchId);
      // }

      if (obj.className == this.classNameArr[0].val) {
        // 获取车辆成本打印数据
        this.$API
          .getCarCostPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取发车配载清单
        this.$API
          .getDispatchPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // 打印-确定模板的数据
    handleOk(obj) {
      console.log(obj, "obj");
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = this.idarrs || [];
      // for (let i = 0; i < this.selectTableData.length; i++) {
      //   idarr.push(this.selectTableData[i].dispatchId);
      // }
      if (obj.className == this.classNameArr[0].val) {
        this.$API
          .getCarCostPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取发车配载清单
        this.$API
          .getDispatchPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // ==================打印插件==================
  },
};
</script>
  <style scoped lang="less">
.textArea {
  height: auto !important;
}

.uploadImg {
  width: 46%;
}

.qsr {
  display: flex;
  // align-items: center;
}
</style>